import { PaymentManagementActiveState } from '@layout/payment-management-active/store/states/payment-management-active.state';

export const paymentManagementActiveState = [PaymentManagementActiveState];
